import { useEffect, useState } from "react";

import { useTranslation } from "react-i18next";

import DialogActions from "components/Actions/dialogs/components/DialogActions";
import { EditInlineDialogProps } from "components/Actions/dialogs/types/interfaces";
import { DEVICE_MODEL_ACTIONS } from "components/Actions/types/enums";
import Autocomplete from "components/DesignComponents/Autocomplete";
import Dialog from "components/DesignComponents/Dialog";
import InputField, {
    INPUT_FIELD_SIZES
} from "components/DesignComponents/InputField";
import { useApi } from "shared/hooks/useApi";
import { useMediaQueries } from "shared/hooks/useMediaQueries";
import { DROPDOWN_SIZES, ENDPOINTS, FILTER_NAMES } from "shared/types/enums";

const EditCompatibilityInline = ({
    data,
    isOpen,
    close
}: EditInlineDialogProps) => {
    const { t } = useTranslation();
    const { toMd } = useMediaQueries();
    const { updateData, handleResponse } = useApi();

    const [isLoading, setIsLoading] = useState(false);
    const [value, setValue] = useState<boolean | null>(null);

    useEffect(() => {
        data && setValue(data[FILTER_NAMES.TaskSupport]);
    }, [data]);

    const handleValueChange = (newValue: boolean) => setValue(newValue);

    const handleSubmit = async () => {
        const payload = {
            [FILTER_NAMES.TaskSupport]: value
        };

        try {
            setIsLoading(true);

            const response = await updateData(
                ENDPOINTS.DeviceModelTaskCompatibilities,
                data.id,
                payload
            );

            close();
            handleResponse(response);
        } catch (error) {
            handleResponse(error);
        }

        setIsLoading(false);
    };

    return (
        <Dialog
            title={t(`General##${DEVICE_MODEL_ACTIONS.EditCompatibility}`)}
            isTitleSeparator
            isActionsSeparator
            open={isOpen}
            close={close}
            submit={handleSubmit}
            slotProps={{
                transition: {
                    onExited: () => {
                        setValue(null);
                        setIsLoading(false);
                    }
                }
            }}
            actions={
                <DialogActions
                    onClose={close}
                    isLoading={isLoading}
                    isReadyToConfirm={value !== null}
                />
            }
            extendToMaxWidth={toMd}
        >
            <InputField
                size={INPUT_FIELD_SIZES.Medium}
                fullWidth
                readOnly
                value={data?.model_name || ""}
                labelLeft={t("Table##model")}
            />

            <Autocomplete
                fullWidth
                isRequired
                size={DROPDOWN_SIZES.Medium}
                textFieldParams={{
                    placeholder: t("Table##compatibility")
                }}
                disableClearable
                options={[true, false]}
                value={value}
                labelLeft={t("Table##status")}
                getOptionLabel={(option: boolean) =>
                    t(
                        `General##boolean filtered value name##${FILTER_NAMES.TaskSupport}##${option}`
                    )
                }
                readOnly={isLoading}
                onChange={(_, newValue) => handleValueChange(newValue)}
                customStyle={{ marginTop: "16px" }}
            />
        </Dialog>
    );
};

export default EditCompatibilityInline;
